import React, { memo } from "react";

const PlaygroundIcon: React.FC = memo(() => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="13"
      viewBox="0 0 16 13"
      fill="currentColor"
    >
      <path
        d="M1.1 11.2996V11.7996H1.6H14.4H14.9V11.2996V3.29961V2.79961H14.4H1.6H1.1V3.29961V11.2996ZM4.39689 4.8036L6.89289 7.29961L4.4 9.7925L3.9854 9.37791L5.69526 7.65145L6.0454 7.29791L5.69355 6.94606L3.97025 5.22275L4.39689 4.8036ZM1.6 12.3996C1.29366 12.3996 1.04387 12.2964 0.823553 12.0761C0.60324 11.8557 0.5 11.6059 0.5 11.2996V1.69961C0.5 1.39327 0.60324 1.14348 0.823553 0.923163C1.04387 0.70285 1.29366 0.599609 1.6 0.599609H14.4C14.7063 0.599609 14.9561 0.70285 15.1764 0.923163C15.3968 1.14348 15.5 1.39327 15.5 1.69961V11.2996C15.5 11.6059 15.3968 11.8557 15.1764 12.0761C14.9561 12.2964 14.7063 12.3996 14.4 12.3996H1.6ZM8.5 9.99961V9.39961H12.3V9.99961H8.5Z"
        fill="currentColor"
        stroke="currentColor"
      />
    </svg>
  );
});

export { PlaygroundIcon };
